module.exports = __webpack_public_path__ + "static/media/1023272.710c4e90.png";